import React from 'react'
import DocSelector from './doc-selector'
import { IncomeDocument } from '@oneethos/shared'

interface BorrowerDocUploadProps {
  title: string
  incomeDocuments: IncomeDocument[]
  onDocTypeChange: (
    ev: React.ChangeEvent<HTMLSelectElement>,
    index: number,
    isCoBorrower: boolean,
    isPrimary: boolean
  ) => void
  onDocSubTypeChange: (
    ev: React.ChangeEvent<HTMLSelectElement>,
    index: number,
    isCoBorrower: boolean
  ) => void
  onChangeDoc: (isCoBorrower: boolean, index: number, documents: File[]) => void
  isCoBorrower: boolean
  isJointApp: boolean
}

const BorrowerDocUpload: React.FC<BorrowerDocUploadProps> = ({
  title,
  incomeDocuments,
  onDocTypeChange,
  onDocSubTypeChange,
  onChangeDoc,
  isCoBorrower,
  isJointApp,
}) => {
  return (
    <>
      {isCoBorrower ? <h3>{title}</h3> : <h2>{title}</h2>}
      <DocSelector
        key={0}
        docs={incomeDocuments[0]?.documents}
        docType={incomeDocuments[0]?.docType ?? ''}
        docSubType={incomeDocuments[0]?.docSubType}
        onDocTypeChange={(ev: React.ChangeEvent<HTMLSelectElement>) =>
          onDocTypeChange(ev, 0, isCoBorrower, true)}
        onDocSubTypeChange={(ev: React.ChangeEvent<HTMLSelectElement>) =>
          onDocSubTypeChange(ev, 0, isCoBorrower)}
        onChange={(docs) => onChangeDoc(isCoBorrower, 0, docs)}
        isJointApp={isJointApp}
      />
      {incomeDocuments.slice(1).map((docSet, index) => (
        <DocSelector
          key={index + 1}
          docs={docSet.documents}
          docType={docSet.docType}
          docSubType={docSet.docSubType}
          onDocTypeChange={(ev: React.ChangeEvent<HTMLSelectElement>) =>
            onDocTypeChange(ev, index, isCoBorrower, false)}
          onDocSubTypeChange={(ev: React.ChangeEvent<HTMLSelectElement>) =>
            onDocSubTypeChange(ev, index + 1, isCoBorrower)}
          onChange={(docs) => onChangeDoc(isCoBorrower, index + 1, docs)}
          isJointApp={isJointApp}
        />
      ))}
    </>
  )
}

export default BorrowerDocUpload